import { Controller } from "@hotwired/stimulus"
import * as Log from "web-ui/log"

// Connects to data-controller="switch"
export default class extends Controller {
  connect() {
    this.debug("Connect")

    this.element.addEventListener("change", this.submitForm)
  }

  disconnect() {
    this.debug("Disconnect")

    this.element.removeEventListener("change", this.submitForm)
  }

  submitForm = (e) => {
    const option = e.target
    const form = option.form

    this.debug("Submitting form", { id: form.id, optionId: option.id })

    form.requestSubmit()
  }

  debug(message, data) {
    Log.debug("Switch - " + message, data)
  }
}
